import React from "react";
import "./ToolStatePanel.css";

export { default as TableSkeleton } from "./TableSkeleton";

export default function ToolStatePanel({
  variant = "empty",
  badge,
  title,
  body,
  actions,
  children,
}) {
  return (
    <div
      className={`nfl-state nfl-state-${variant}`}
      role={variant === "error" ? "alert" : "status"}
    >
      {badge !== undefined && badge !== null ? (
        <div className="nfl-state-badge" aria-hidden="true">
          {badge}
        </div>
      ) : null}
      <h2 className="nfl-state-title">{title}</h2>
      {body ? <p className="nfl-state-body">{body}</p> : null}
      {actions ? <div className="nfl-state-actions">{actions}</div> : null}
      {children}
    </div>
  );
}
